import { FC } from 'react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import tw from 'twin.macro';
import 'styled-components/macro';

import logo from '../../../../assets/images/instruqt.svg';
import { AccountActions } from './account/AccountActions';
import { AccountButton, AccountButtonProps } from './account/AccountButton';
import { MainMenu } from './MainMenu';
import { MenuButton } from './MenuButton';

export interface AppBarProps extends React.HTMLAttributes<HTMLElement> {
  teamSlug?: string;
  onOpen?: () => void;
  open?: boolean;
  profile?: AccountButtonProps['profile'];
  shouldHideAccountActions?: boolean;
  shouldHideContent?: boolean;
  shouldHideInspirationLibrary?: boolean;
  title?: string;
  renderAnnouncements?: FC;
}

export const AppBar: FC<AppBarProps> = ({
  teamSlug,
  onOpen,
  open,
  profile,
  shouldHideAccountActions,
  shouldHideContent,
  shouldHideInspirationLibrary,
  title,
  renderAnnouncements,
}) => {
  return (
    <div tw="flex items-center bg-white px-4 h-[88px]">
      <Link to="/">
        <div aria-label="logo">
          <img tw="h-5 sm:h-5 mr-2" alt="Instruqt Logo" src={logo} />
        </div>
      </Link>
      <MainMenu
        tw="hidden sm:flex ml-2"
        shouldHideContent={shouldHideContent}
        shouldHideInspirationLibrary={shouldHideInspirationLibrary}
        team={teamSlug}
      />

      <div tw="flex-grow" />
      {title && <span tw="text-lg sm:hidden">{title}</span>}
      <div tw="flex-grow sm:hidden" />

      <div tw="sm:hidden" css={!open && tw`hidden`}>
        {renderAnnouncements ? renderAnnouncements({}) : null}
      </div>
      <MenuButton tw="sm:hidden ml-3" open={open} onClick={onOpen} />
      {profile ? (
        <div tw="hidden sm:flex">
          {renderAnnouncements ? renderAnnouncements({}) : null}
          <AccountButton onClick={onOpen} open={open} profile={profile} tw="ml-2" />
        </div>
      ) : (
        !shouldHideAccountActions && <AccountActions tw="hidden sm:block" />
      )}
    </div>
  );
};
